// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3":"89d96f69","491":"e626066c"}[chunkId] + ".chunk.css";
};